import { ErrorIcon } from './Icons';

function ErrorMessage({ message, title = 'Error' }) {
    return (
        <div className="error-message" role="alert">
            <ErrorIcon />
            <div>
                <strong>{title}: </strong>
                <span>{message}</span>
            </div>
        </div>
    );
}

export default ErrorMessage;